var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { PixelRatio, StyleSheet } from 'react-native';
import hoistNonReactStatics from 'hoist-non-react-statics';
import PropTypes from 'prop-types';
export default function resizeImage(WrappedComponent) {
    var _a;
    let Comp = (_a = class ResizedImage extends Component {
            constructor() {
                super(...arguments);
                this.state = {
                    width: undefined,
                    height: undefined,
                };
            }
            static getDerivedStateFromProps({ style = {} }, { width, height }) {
                const flatStyle = StyleSheet.flatten(style);
                const { width: styleWidth, height: styleHeight } = flatStyle;
                let newState = {};
                if (styleWidth)
                    newState = Object.assign({}, newState, { width: PixelRatio.getPixelSizeForLayoutSize(styleWidth) });
                if (styleHeight)
                    newState = Object.assign({}, newState, { height: PixelRatio.getPixelSizeForLayoutSize(styleHeight) });
                return newState;
            }
            render() {
                const _a = this.props, { source: oriSource, resizeUri } = _a, rest = __rest(_a, ["source", "resizeUri"]);
                const { width, height } = this.state;
                let source = oriSource;
                if (oriSource.uri)
                    source = Object.assign({}, oriSource, { uri: resizeUri(oriSource.uri, { width, height }) });
                return <WrappedComponent {...rest} source={source}/>;
            }
        },
        _a.propTypes = {
            source: PropTypes.oneOfType([PropTypes.object, PropTypes.number]).isRequired,
            /**
             * @param {string} uri - original uri from source.uri
             * @param {object} {width,height} - width and height of image on pixel size
             * @returns {string} source.uri that is used to render the image
             */
            resizeUri: PropTypes.func,
        },
        _a.defaultProps = {
            resizeUri: uri => uri,
        },
        _a);
    Comp = hoistNonReactStatics(Comp, WrappedComponent);
    return Comp;
}
